import React from 'react';
import PropTypes from 'prop-types';

const ArcGisButton = ({
  mapurl,
  buttontxt,
  buttonstyle,
  buttonalign,
  frontend = true,
}) => {
  if (!buttontxt) {
    return null;
  }

  const anchorClasses = [
    (frontend) ? 'arcgisMap_button' : null,
    'wp-block-button__link',
  ].filter((n) => n).join(' ');

  const anchor = (frontend) ? (
    <a
      target="_blank"
      className={anchorClasses}
      rel="noreferrer"
      href={mapurl}
    >
      {buttontxt}
    </a>
  ) : (
    <span
      className="wp-block-button__link"
    >
      {buttontxt}
    </span>
  );

  return (
    <div
      className={`wp-block-button arcgisMap_button_container ${buttonstyle} ${buttonalign}`}
    >
      {anchor}
    </div>
  );
};

ArcGisButton.propTypes = {
  mapurl: PropTypes.string,
  buttontxt: PropTypes.string,
  buttonstyle: PropTypes.string,
  buttonalign: PropTypes.string,
  frontend: PropTypes.bool,
};

ArcGisButton.defaultProps = {
  mapurl: '',
  buttontxt: '',
  buttonstyle: '',
  buttonalign: '',
  frontend: true,
};

export default ArcGisButton;
